import { CarouselPrevious, CarouselNext } from '@/components/atoms/Carousel';

const NAVIGATION_BUTTON_BASE_STYLE =
  'z-[10] opacity-0 transition-opacity duration-500 group-hover:opacity-100 md:opacity-100';

export const CarouselNavigationButtons = () => (
  <>
    <CarouselPrevious className={`left-0 md:-left-12 ${NAVIGATION_BUTTON_BASE_STYLE}`} />
    <CarouselNext className={`right-0 md:-right-12 ${NAVIGATION_BUTTON_BASE_STYLE}`} />
  </>
);
